import { render, staticRenderFns } from "./PopupInfm.vue?vue&type=template&id=6fa65726&"
import script from "./PopupInfm.vue?vue&type=script&lang=js&"
export * from "./PopupInfm.vue?vue&type=script&lang=js&"
import style0 from "./PopupInfm.vue?vue&type=style&index=0&id=6fa65726&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports